import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import IconButton from "@/components/ds/icon-button/IconButton.vue";
import { PropType } from "vue";
import { Project } from "@/types";
import { useRouter } from "vue-router";
import { projectToSlug } from "@/tools/projects";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectButton',
  props: {
    project: {
        type: Object as PropType<Project>,
        required: true,
    },
},
  setup(__props) {

const props = __props;

const router = useRouter();

const toProject = () => {
    const slug = projectToSlug(props.project, -1);
    router.push({ name: "Project", params: { slug } });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IconButton, {
    "icon-id": "arrow-right",
    onClick: toProject
  }, {
    default: _withCtx(() => [
      _createTextVNode("Naar project: " + _toDisplayString(__props.project.projectName), 1)
    ]),
    _: 1
  }))
}
}

})